<div class="review-item {{classOverride}}" [class.readonly]="readOnly" id="ri_{{reviewItem.dataItem}}" (click)="changeStatus($event)">
    @if(reviewItem.heading) {
        <div class="heading">
            @switch(reviewItem.target) {
                @case(0) {
                    <i  class="fa-solid fa-user"></i>
                }
                @case(1) {
                    <i class="fa-solid fa-file"></i>
                }
                @case(2) {
                    <i class="fa-solid fa-file-shield"></i>
                }
            }
            <span>{{reviewItem.heading}}</span>
        </div>
    }
    <div class="edit">
        <div class="status" [ngClass]="reviewItem.status"></div>
        <div class="text" [innerHTML]="reviewItem.text">
            <ng-content select="[reviewText]"></ng-content>
            @if(reviewItem.reviewingUsers.length > 0) {
            <app-cf-user-profile-stack [width]="30" [height]="30"
                [users]="reviewItem.reviewingUsers"></app-cf-user-profile-stack>
            }
        </div>
    </div>
</div>